







import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "ContentFeedCoverAuthor",
  components: { BaseAvatar },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
  data() {
    return {
      getProfileUrl,
    };
  },
});
